var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AboutList',{attrs:{"tableData":_vm.tableData,"name":"取消收藏"},on:{"isCollect":_vm.isCollect,"init":_vm.init}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }